/**
 * @JSdoc Object
 * @name constants.js
 * @description Global constants for entire application
 *
 */

export default {
    
   
    general: {
        rows_per_page: 20,
    }

}
